import AuthenticateBox from '@/src/app/[locale]/profile/components/AuthenticateBox';
import Modal from '../Modal';
import { useSearchParams } from 'next/navigation';
import Link from 'next-intl/link';
import { MdAccountCircle } from 'react-icons/md';
import { useTranslations } from 'next-intl';
import { userState } from '@/src/redux/userSlice/userSlice';
import { RootState } from '@/src/redux/store';
import { useSelector } from 'react-redux';
import { BsExclamationOctagonFill } from 'react-icons/bs';
import { useLocaleRoutes } from '@/src/utils/useLocaleRoutes';

export default function FirstLoginModal() {
  const t = useTranslations('FirstLoginModal');
  const path = useLocaleRoutes();
  const showLogin = useSearchParams().get('modal') === 'first-login';
  const user: userState = useSelector((state: RootState) => {
    return state.user;
  });

  if (!showLogin) {
    return null;
  }
  
  return (
    <Modal>
      <div className='flex flex-col items-center'>
        <span className='mb-4 text-5xl font-semibold uppercase text-brand'>
          {t('title')}
        </span>
        <p>{t('welcomeText')}</p>
        <div className='my-10 mb-6 flex flex-col items-center'>
          <span className='mb-4 text-5xl'>
            <MdAccountCircle />
          </span>
          <span className='mb-1 text-xl font-semibold'>
            {user.firstName} {user.lastName}
          </span>
          <span className='text-sm mt-1 px-8 py-2 rounded-xl border-brand border flex justify-center items-center gap-1'><span className='text-brand-alt'><BsExclamationOctagonFill /></span> {t('notVerified')}</span>
          {(user.email || user.cellphone) &&
          (<div className='mt-6 flex flex-col items-center'>
            <span>{user.email}</span>
            <span>{user.cellphone}</span>
          </div>)}
        </div>
        <div className='my-6 text-center'>{t.rich('advantagesOfAuthentication',{
          header: (chunks) => <h3 className='font-bold text-brand text-lg'>{chunks}</h3>,
          br: () => <br />,
        })}</div>
        <div className='flex flex-col'>
          <AuthenticateBox />
          <p className='font-bold mt-6 mb-2'>{t('authenticateOnProfile')}</p>
          <Link
            href={`/${path('profile')}`}
            className='rounded-sm border border-white px-4 py-2 text-center font-semibold uppercase transition-all hover:border-brand hover:bg-brand hover:text-dark'
          >
            {t('goToProfile')}
          </Link>
        </div>
      </div>
    </Modal>
  );
}
